import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetSocialChallengeDetailV1Response } from './get-social-challenge-detail-v1-response';
import { getSocialChallengeDetailV1ResponseSchema } from './get-social-challenge-detail-v1-response';

export async function getSocialChallengeDetailV1Api(
  challengeId: number,
): Promise<IValidatedResponse<IGetSocialChallengeDetailV1Response>> {
  return getRequest<IGetSocialChallengeDetailV1Response>({
    path: `/sys/social/v1/challenges/${challengeId}`,
    schema: getSocialChallengeDetailV1ResponseSchema,
  });
}
